import getCookie from "./csrftoken.js";

function customHttpGetAsync(theUrl, callback)
{
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function() { 
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
            callback(xmlHttp.responseText);
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}

function CollectionButton(element) {
    this.containerElement = element,
    this.projectId = '';
    this.initialized = false;
    this.containerLink =  null;
    this.collectionListOpen = false;
    this.collectionListElement = null;
    this.collectionListAddElement = null;

    this.initialize = function() {
        this.projectId = this.containerElement.dataset.projectId;
        this.containerLink = this.containerElement.querySelector('.js-entry-button-collection__link');
        this.containerLink.addEventListener("click", this.editClicked.bind(this), false);
    };

    this.editClicked = function(event) {
        event.preventDefault();

        if (!this.initialized) {
            this.collectionListElement = document.createElement("ul");
            this.collectionListElement.classList.add('collection-list');

            /** input field */
            this.collectionListAddElement = document.createElement("li");
            this.collectionListAddElement.classList.add('collection-list__add-element');

            this.collectionListAddInputElement = document.createElement("input");
            this.collectionListAddInputElement.classList.add('collection-list__add-element__input');
            this.collectionListAddInputElement.type = "text";
            this.collectionListAddInputElement.placeholder = 'Add new collection';
            this.collectionListAddInputElement.addEventListener("keydown", this.onEnterPress.bind(this), false);
            this.collectionListAddElement.appendChild(this.collectionListAddInputElement);

            this.collectionListElement.appendChild(this.collectionListAddElement);

            this.pullListData();
            this.initialized = true;
        }

        this.collectionListOpen = !this.collectionListOpen;
        this.renderCollectionList();
    };

    this.onEnterPress = function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            if (this.collectionListAddInputElement.value != '') {
                this.addCollection(this.collectionListAddInputElement.value);
            }
        }
    }

    this.addCollection = function(collectionName) {
        let url = '/list/create/' + this.projectId + '/';
        let xhr = new XMLHttpRequest();
        let csrftoken = getCookie('csrftoken');
        let params = "listName=" + collectionName;
        xhr.open("POST", url, false);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
        xhr.send(params);
        var resp = JSON.parse(xhr.responseText);

        let listItem = document.createElement("li");
        listItem.classList.add('collection-list__item');

        let listItemCheckBox = document.createElement("input");
        listItemCheckBox.type = "checkbox";
        listItemCheckBox.classList.add('collection-item__checkbox');
        listItemCheckBox.name = 'collectionId';
        listItemCheckBox.value = resp.list_pk ?? '';
        listItemCheckBox.checked = true;
    
        let listItemText = document.createElement("span");
        listItemText.classList.add('collection-item__text');
        listItemText.innerText = collectionName ?? '';
        listItem.appendChild(listItemCheckBox);
        listItem.appendChild(listItemText);
        listItem.addEventListener("click", this.listClicked.bind(this), false);
        this.collectionListElement.insertBefore(listItem, this.collectionListAddElement);

        this.collectionListAddInputElement.value = '';
        this.collectionListOpen = false;
        this.renderCollectionList();
    }

    this.pullListData = function() {
        let url = '/user/user_lists/get/';
        let xhr = new XMLHttpRequest();
        let csrftoken = getCookie('csrftoken');
        xhr.open("GET", url, false);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
        xhr.send();
        var resp = JSON.parse(xhr.responseText);
        if (resp.length > 0) {
            for (var i = 0; i < resp.length; i++) {
                let listItem = this.buildListItems(resp[i]);
                if (listItem) {
                    this.collectionListElement.insertBefore(listItem, this.collectionListAddElement);
                }
            }
        }
    };

    /** builds a list item */
    this.buildListItems = function(listItemData) {
        let listItem = document.createElement("li");
        listItem.classList.add('collection-list__item');

        let listItemCheckBox = document.createElement("input");
        listItemCheckBox.type = "checkbox";
        listItemCheckBox.classList.add('collection-item__checkbox');
        listItemCheckBox.name = 'collectionId';
        listItemCheckBox.value = listItemData.pk ?? '';

        if (listItemData.fields.projects.length > 0) {
            for (var i = 0; i < listItemData.fields.projects.length; i++) {
                if (listItemData.fields.projects[i] == this.projectId) {
                    listItemCheckBox.checked = true;
                }
            }
        }

        let listItemText = document.createElement("span");
        listItemText.classList.add('collection-item__text');
        listItemText.innerText = listItemData.fields.name ?? '';
        listItem.appendChild(listItemCheckBox);
        listItem.appendChild(listItemText);

        
        listItem.addEventListener("click", this.listClicked.bind(this), false);

        return listItem;
    }

    this.listClicked = function(event) {
        let listItem = event.target;
        if (!listItem.classList.contains('collection-list__item')) {
            listItem = event.target.parentElement;
        }

        let listItemCheckbox = listItem.getElementsByClassName('collection-item__checkbox');
        if (listItemCheckbox.length > 0) {
            this.saveList(listItemCheckbox[0].value);
            if (!event.target.classList.contains('collection-item__checkbox')) {
                listItemCheckbox[0].checked = !listItemCheckbox[0].checked;
            }
        }
    }

    this.saveList = function(listId) {
        let url = '/user/user_lists/save/' + listId + '/' + this.projectId + '/';
        let xhr = new XMLHttpRequest();
        let csrftoken = getCookie('csrftoken');
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
        xhr.onreadystatechange = function() { // Call a function when the state changes.
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                console.log('Update complete');
            }
        }
        xhr.send();
        this.collectionListOpen = !this.collectionListOpen;
        this.renderCollectionList();
    }

    this.renderCollectionList = function() {
        this.containerElement.classList.toggle('entry__button--selected');
        if (this.collectionListOpen) {
            this.containerElement.appendChild(this.collectionListElement);
        } else {
            this.containerElement.removeChild(this.collectionListElement);
        }
    }
}



document.addEventListener("DOMContentLoaded", function(event) {
    let buttonElement = document.getElementsByClassName('js-entry-button-collection');
    for (var i = buttonElement.length - 1; i >= 0; i--) {
        let buttonComponent = new CollectionButton(buttonElement[i]);
        buttonComponent.initialize();
    }
});